let hasJustLoggedIn = false;

if (typeof window !== "undefined") {
  window.addEventListener(
    "AsosAuthClient.onLoggedIn",
    () => (hasJustLoggedIn = true)
  );
}

export default () => hasJustLoggedIn;
